import { useDesktopView } from 'utils/hooks/useDesktopView'

/**
 * Controls whether the desktop responsive layout is active for /dokumen pages.
 *
 * Driven by the Toggle SDK key 'dokumen-desktop-view-enabled'.
 * - false (default): always renders mobile layout
 * - true: uses actual viewport — desktop layout activates at >=768px
 */
export const useDocumentDesktopView = () =>
  useDesktopView('dokumen-desktop-view-enabled')
